@if (isDownloading$ | async) {
  <app-export-status [exportObject]="dashboard"></app-export-status>
}

<!-- Second Pane -->
<div class="dashboard">
  <div class="panes">
    <app-page-navigator-for-dashboard
      [pages]="dashboardPages$ | async"
      [selectedPageId]="selectedPageId$ | async"
      [dashboardId]="dashboard.id"
      [presentationSettings]="dashboard.presentation_settings"
      [title]="'Dashboard Pages'"
      [addButtonText]="'Add New Page'"
      [allowAdd]="true"
      (pageSelected)="selectPage($event)"
      (pageAdded)="createPage()"
      (pageDeleted)="deletePage($event)"
      (pageVisibilityToggled)="onPageVisibilityToggle($event)"
      (pageReordered)="reorderPages($event)"
    ></app-page-navigator-for-dashboard>

    <div class="pane pane-single">
      @if (selectedPage$ | async; as selectedPage) {
        <div class="page-header">
          <div class="title-container">
            @if (!editingTitle) {
              <h2 class="page-name">
                <span
                  class="editable-text"
                  (click)="startEditingTitle(selectedPage.name)"
                >
                  {{ selectedPage.name }}
                </span>
                <fa-icon
                  [icon]="faPenToSquare"
                  class="edit-icon"
                  (click)="startEditingTitle(selectedPage.name)"
                ></fa-icon>
              </h2>
            }
            @if (editingTitle) {
              <sui-input
                type="text"
                [(ngModel)]="editTitleValue"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="onTitleKeydown($event)"
                (focusout)="saveTitle()"
                #titleInput
              ></sui-input>
            }
            <app-dashboard-auto-refresh-counter
              [secondsLeft]="autoReloadSecondsLeft$ | async"
              [cacheEnabled]="cacheEnabled$ | async"
            ></app-dashboard-auto-refresh-counter>
          </div>
          <div class="description-container">
            @if (!editingDescription) {
              <p class="page-description">
                <span
                  class="editable-text"
                  (click)="startEditingDescription(selectedPage.description)"
                >
                  {{ selectedPage.description || "No Description" }}
                </span>
                <fa-icon
                  [icon]="faPenToSquare"
                  class="edit-icon"
                  (click)="startEditingDescription(selectedPage.description)"
                ></fa-icon>
              </p>
            }
            @if (editingDescription) {
              <sui-input
                type="text"
                [(ngModel)]="editDescriptionValue"
                [ngModelOptions]="{ standalone: true }"
                (keydown)="onDescriptionKeydown($event)"
                (focusout)="saveDescription()"
                #descriptionInput
              ></sui-input>
            }
          </div>
        </div>
      }

      <app-widget-toolbar
        (searchChange)="searchWidgets($event)"
        (refresh)="refreshWidgets()"
        (selectAllChange)="selectAllWidgets($event)"
      ></app-widget-toolbar>

      @if (
        {
          selectedPlaceholderId: selectSelectedPlaceholderId$ | async,
          editMode: currentObjectEditMode$ | async,
          objectViewProperties: objectViewProperties$ | async,
          widgets: currentPageWidgets$ | async,
          loading: widgetsLoading$ | async,
        };
        as data
      ) {
        <div class="card-container widgets h-100">
          @if (data.loading) {
            <div class="app-loading-wrapper">
              <app-loading-card type="widget" [count]="1"></app-loading-card>
            </div>
          }
          <!-- Show message if no widgets and not loading -->
          @if (
            !data.loading &&
            (!data.widgets || data.widgets.length === 0) &&
            loadWidgetPassed
          ) {
            <div class="app-loading-wrapper">
              <div class="no-widgets-message">
                {{ "dashboard.no-widgets-message" | translate }}
              </div>
            </div>
          }
          @if (data.widgets && data.widgets.length > 0) {
            <gridstack
              [options]="gridsterConfig"
              (changeCB)="onGridChange($event)"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              @for (widget of data.widgets; track trackByFn($index, widget)) {
                <gridstack-item
                  [options]="{
                    x: widget.x,
                    y: widget.y,
                    w: widget.cols,
                    h: widget.rows,
                    id: widget.id,
                    noResize:
                      widget.widget_type_id ===
                      WidgetType.WIDGET_TYPE_PLACEHOLDER,
                  }"
                >
                  <app-widget-card
                    [widget]="widget"
                    [currentObject]="dashboard"
                    [isPlaceholderSelected]="
                      widget.id === data.selectedPlaceholderId
                    "
                    [objectActionService]="objectActionService"
                    [editMode]="data.editMode"
                    [viewProperties]="data.objectViewProperties"
                    [resizingWidgetId$]="resizingWidgetId$"
                    [isDragging$]="isDragging$"
                  ></app-widget-card>
                </gridstack-item>
              }
            </gridstack>
          }
        </div>
      }
    </div>
  </div>
  <!-- Sidebar -->
  <app-sidebar
    [buttons]="sidebarButtons"
    (componentSelected)="loadComponent($event)"
  ></app-sidebar>
</div>

<!-- Presentation Overlay -->
<app-dashboard-presentation-mode
  [isVisible]="showPresentationMode"
  [singlePageId]="presentationSinglePageId"
  (exitPresentation)="exitPresentationMode()"
>
</app-dashboard-presentation-mode>

<!-- ✅ Child Route Outlet - for page/:pageId routes -->
<router-outlet></router-outlet>
